/*=============== GET LANGUAGE ===============*/
export function getLanguage() {
    let pathname = window.location.pathname; // Returns path only (/path/example.html)
    pathname = pathname.split('/');
    let spanish = pathname.indexOf('es');
    if (spanish > -1) {
        // si idioma es español
        return 'es';
    } else {
        return 'en';
    }
}